import { useEffect, useState } from "react";
import { ensureAccessProbe } from "@/features/intelligence/lib/access-probe";

export function useCreateClientToolArmed(): boolean {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    let live = true;
    void ensureAccessProbe().then((answer) => {
      if (live) setArmed(answer.access === "ok");
    });
    return () => {
      live = false;
    };
  }, []);

  return armed;
}
